import Vue from 'vue';
import router from '../router';
import store from '../store';

const state = () => ({
    current: null,
    currentIframeServiceNumber: null,
    autorizedIframeInstances: null,
    incidentEmails: null,
    service: null,
    list: null,
    currentDocsPortlet: null,
    dashboardId: null,
    dashboards: null,
    listResult: null,
    portletsList: [],
    currentPortlet: '',
    portletId: null,
    bookmarks: {},
    nbShipments: null,
    servicesBookmarks: {},
    portletsBookmarks: [],
    services: {
        deliveries: {
            name: 'deliveries',
            breadcrumb_label: 'Urgent deliveries',
            routes: [
                {
                    name: 'Liste',
                    url: '/deliveries',
                    subpages: [
                        {
                            name: 'NIN',
                            url: 'NIN'
                        },
                        {
                            name: 'NCN',
                            url: 'NCN'
                        }
                    ]
                }
            ]
        },
        trackandtrace: {
            name: 'trackandtrace',
            breadcrumb_label: 'T&T search',
            routes: [
                {
                    name: 'Liste',
                    url: '/trackandtrace',
                    subpages: [
                        {
                            name: 'trackandtrace.details.details',
                            translated: true,
                            url: 'Details'
                        },
                        {
                            name: 'trackandtrace.events.events',
                            number: null,
                            translated: true,
                            url: 'Events'
                        },
                        {
                            name: 'trackandtrace.documents.documents',
                            number: null,
                            translated: true,
                            url: 'Documents'
                        },
                        {
                            name: 'trackandtrace.content.content',
                            number: null,
                            translated: true,
                            url: 'Contents'
                        }
                    ]
                }
            ]
        },
        docs: {
            name: 'docs',
            breadcrumb_label: 'Docs',
            routes: [
                {
                    name: 'File browser',
                    url: '/docs'
                }
            ]
        },
        BI: {
            name: 'BI',
            breadcrumb_label: 'BI',
            routes: [
                {
                    name: 'BI',
                    url: '/BI'
                }
            ]
        },
        BPM: {
            name: 'BPM',
            breadcrumb_label: 'BPM',
            routes: [
                {
                    name: 'BPM',
                    url: '/BPM'
                }
            ]
        },
        genericsearch: {
            name: 'genericsearch',
            breadcrumb_label: 'Generic search',
            routes: [
                {
                    name: 'Generic search',
                    url: '/genericsearch'
                }
            ]
        },
        IFRAME: {
            name: 'IFRAME',
            breadcrumb_label: 'IFRAME service',
            routes: [
                {
                    name: 'IFRAME',
                    url: '/IFRAME'
                }
            ]
        },
        Statistic: {
            name: 'Statistic',
            breadcrumb_label: 'Statistics',
            routes: [
                {
                    name: 'Statistic',
                    url: '/Statistic'
                }
            ]
        }
    }
});

const getters = {
    _getClient: state => {
        if (state.current === null || state.list === null) return null;
        let i;
        for (i = 0; i < state.list.length && state.list[i].id !== state.current; i += 1);
        return i !== state.list.length ? state.list[i] : null;
    },
    getCurrentDashboardId: state => {
        return state.dashboardId;
    },
    getDashboards: state => {
        return state.dashboards;
    },
    getClientName: (state, getters) => {
        const client = getters._getClient;
        const pathName = document?.location?.pathname;
        if ((pathName.startsWith('/OSOL') || pathName.includes('/OSOL/')) && router?.currentRoute?.query.osol) return 'OSOL';
        return client ? client.name : 'admin';
    },
    getCurrentClientId: (state, getters) => {
        const client = getters._getClient;
        return client ? client.id : null;
    },
    getServiceName: (state, getters) => {
        return state.service;
    },
    getIframeServiceNumber: (state, getters) => {
        return state.currentIframeServiceNumber;
    },
    getAuthorizedInstances: (state, getters) => {
        return state.autorizedIframeInstances;
    },
    getCurrentDocsPortlet: (state, getters) => {
        return state.currentDocsPortlet;
    },

    getCurrentDocsPortletAccess: (state, getters) => {
        if (state.currentDocsPortlet) {
            const docServiceAccess = getters.getClientServices.find(
                service => service.service === 'DOCS' && service.id === state.currentDocsPortlet
            );

            if (docServiceAccess) {
                const { viewer, writer } = docServiceAccess;
                return {
                    viewer,
                    writer
                };
            }

            return;
        }
        return null;
    },
    getClientLogo: (state, getters) => {
        if (state.current === null || state.list === null) {
            return null;
        }
        const client = getters._getClient;
        return client ? client.logo : null;
    },
    getClientServices: (state, getters) => {
        if (state.list === null) {
            return null;
        }
        const client = getters._getClient;
        if (client === null || state.current === null || !client.services) {
            return [];
        }
        return client.services;
    },
    getServiceRoutes: (state, getters) => {
        if (state.current === null || state.service === null) {
            return [];
        }
        const client = getters._getClient;
        const serviceName = getters.getServiceName || client.services[state.service].name;

        return state.services[serviceName].routes;
    },
    getServiceSubpages: (state, getters) => {
        if (!state.service) return [];

        const serviceName = getters.getServiceName;

        if (
            !serviceName ||
            !state.services[serviceName] ||
            !state.services[serviceName].routes ||
            !state.services[serviceName].routes[0] ||
            !store.state.groups.authorization?.subpages
        ) {
            return [];
        }

        return state.services[serviceName].routes[0].subpages.filter(subpage =>
            store.state.groups.authorization.subpages.find(name => name === subpage.name)
        );
    },
    getNbShipments: state => {
        return state.nbShipments;
    },
    getListResult: state => {
        return state.listResult;
    },
    getPortletsList: state => {
        return state.portletsList;
    },
    getPortletId: state => {
        return state.portletId;
    },
    getCurrentPortlet: state => {
        return state.currentPortlet;
    },
    getServiceHeader: state => {
        if (state.list) {
            const index = state.list.findIndex(client => client.id === state.current);
            if (index >= 0 && state.list) {
                return state.list[index].templateHeader;
            }
        }
        return;
    },
    getServiceFooter: state => {
        if (state.list) {
            const index = state.list.findIndex(client => client.id === state.current);
            if (index >= 0 && state.list) {
                return state.list[index].templateFooter;
            }
        }
        return;
    },
    getBookmarks: state => {
        return (
            (state.list &&
                state.list.filter(client => {
                    return state.bookmarks[client.id];
                })) ||
            []
        );
    },
    getBookmarkedServices: state => {
        if (state.list) {
            const currentClient = state.list.find(client => client.id === state.current);

            if (currentClient) {
                const { servicesBookmarks } = state;
                const bookmarkedService = currentClient.services.filter(service => {
                    if (servicesBookmarks[currentClient.id]) {
                        return servicesBookmarks[currentClient.id][service.name];
                    }
                    return false;
                });
                return bookmarkedService;
            }
        }
        return [];
    },
    getServices: state => {
        if (state.list) {
            const currentClient = state.list.find(client => client.id === state.current);

            if (currentClient) {
                const { servicesBookmarks } = state;

                const services = currentClient.services.filter(service => {
                    if (servicesBookmarks[currentClient.id] && servicesBookmarks[currentClient.id][service.name]) {
                        return false;
                    }
                    return true;
                });
                return services;
            }
        }
        return [];
    },
    getBookmarkedServicePortlets: state => portlets => {
        if (portlets) {
            const clientId = state.current;
            const serviceName = state.service;
            if (clientId && serviceName) {
                const { portletsBookmarks } = state;
                const bookmarkedPortlets = portlets.filter(portlet => {
                    if (portlet.client_id === clientId) {
                        const poBookmark = portletsBookmarks.find(
                            p => p.idClient === clientId && p.serviceName === serviceName && p.portletId === portlet.id
                        );
                        if (poBookmark) {
                            return poBookmark.bookmark;
                        }
                    }
                    return false;
                });
                return bookmarkedPortlets;
            }
        }
        return [];
    },
    getServicePortlets: state => portlets => {
        if (portlets) {
            const clientId = state.current;
            const serviceName = state.service;
            if (clientId && serviceName) {
                const { portletsBookmarks } = state;
                const bookmarkedPortlets = portlets.filter(portlet => {
                    if (portlet.client_id === clientId) {
                        const poBookmark = portletsBookmarks.find(
                            p => p.idClient === clientId && p.serviceName === serviceName && p.portletId === portlet.id
                        );
                        if (poBookmark && poBookmark.bookmark) return false;
                    }
                    return true;
                });
                return bookmarkedPortlets;
            }
        }
        return [];
    },
    getClients: state => {
        return (state.list && state.list.filter(client => !state.bookmarks[client.id])) || [];
    }
};

const mutations = {
    routeChanged(state, { data, getters }) {
        if (state.current === null || state.service === null || state.list === null) return null;
        let client = null;
        for (let i = 0; i < state.list.length; i++) {
            if (state.list[i].id === state.current) {
                client = state.list[i];
                break;
            }
        }
        const serviceName = getters.getServiceName || client.services[state.service].name;
        state.services[serviceName].routes = [...state.services[serviceName].routes];
    },
    resetClient(state) {
        Vue.set(state, 'current', null);
        Vue.set(state, 'service', null);
        Vue.set(state, 'incidentEmails', null);
    },
    resetServices(state) {
        Vue.set(state, 'service', null);
    },
    setClientService(state, name) {
        Vue.set(state, 'service', name);
    },
    setIframeServiceNumber(state, serviceNumber) {
        Vue.set(state, 'currentIframeServiceNumber', serviceNumber);
    },
    setAutorizedIframeInstances(state, serviceNumber) {
        Vue.set(state, 'autorizedIframeInstances', serviceNumber);
    },
    setCurrent(state, id) {
        Vue.set(state, 'current', id);
        const incidentEmails = state?.list?.find(client => client?.id === id)?.incidentEmails;
        Vue.set(state, 'incidentEmails', incidentEmails || null);
    },
    setClients(state, clients) {
        Vue.set(state, 'list', clients);
    },
    setDashboards(state, dashboards) {
        state.dashboards = dashboards;
    },
    setDashboardId(state, id) {
        Vue.set(state, 'dashboardId', id);
    },
    setListResult(state, listResult) {
        state.listResult = listResult;
    },
    resetListResult(state) {
        state.listResult = null;
    },
    setCurrentPortlet(state, name) {
        state.currentPortlet = name;
    },
    setGSPortlets(state, list) {
        state.portletsList = list;
    },
    setGSPortletId(state, id) {
        state.portletId = id;
    },
    setCurrentDocsPortlet(state, id) {
        Vue.set(state, 'currentDocsPortlet', id);
    },
    setClientFromSession: (state, selectedClient) => {
        state.current = selectedClient.id;
        state.list = [selectedClient];
        state.incidentEmails = selectedClient.incidentEmails || null;
    },
    setBookmark: (state, idClient) => {
        if (!state.bookmarks[idClient]) {
            state.bookmarks[idClient] = true;
        } else {
            state.bookmarks[idClient] = !state.bookmarks[idClient];
        }
        state.bookmarks = Object.assign({}, state.bookmarks);
    },
    setServiceBookmark: (state, serviceName) => {
        const idClient = state.current;

        if (!state.servicesBookmarks[idClient]) {
            state.servicesBookmarks[idClient] = {};
            state.servicesBookmarks[idClient][serviceName] = true;
        } else {
            if (!state.servicesBookmarks[idClient][serviceName]) {
                state.servicesBookmarks[idClient][serviceName] = true;
            } else {
                state.servicesBookmarks[idClient][serviceName] = !state.servicesBookmarks[idClient][serviceName];
            }
        }
        state.servicesBookmarks = Object.assign({}, state.servicesBookmarks);
    },
    setClientsBookmarks(state, bookmarks) {
        state.bookmarks = Object.assign({}, bookmarks);
    },
    setServicesBookmarks(state, { clientId, servicesBookmarks }) {
        state.servicesBookmarks[clientId] = servicesBookmarks;
        state.servicesBookmarks = Object.assign({}, state.servicesBookmarks);
    },
    setSubpageNumber(state, { subpage, number }) {
        const serviceName = state.service;
        const routes = state.services[serviceName].routes;
        for (let i = 0; i < routes.length; i++) {
            for (let j = 0; j < routes[i].subpages.length; j++) {
                if (subpage === routes[i].subpages[j].name) {
                    Vue.set(routes[i].subpages[j], 'number', number);
                }
            }
        }
    },
    setFavorite(state, args) {
        for (let i = 0; i < state.list.length; i++) {
            if (state.list[i].id === args.id) {
                state.list[i].favorite = args.value;
                break;
            }
        }
    },
    setNbShipments(state, value) {
        state.nbShipments = value;
    },
    setPortletBookmark: (state, portletId) => {
        const idClient = state.current;
        const serviceName = state.service;

        const i = state.portletsBookmarks.findIndex(
            p => p.idClient === idClient && p.serviceName === serviceName && p.portletId === portletId
        );

        if (i > -1) {
            const currentPortlet = state.portletsBookmarks[i];
            currentPortlet.bookmark = !currentPortlet.bookmark;
            state.portletsBookmarks.splice(i, 1, currentPortlet);
        } else {
            state.portletsBookmarks.splice(0, 0, { idClient, serviceName, portletId, bookmark: true });
        }
    },
    setPortletsBookmarks(state, portletsBookmarks) {
        state.portletsBookmarks = portletsBookmarks;
    }
};

const actions = {
    callRouteChanged({ commit, getters }, data) {
        commit('routeChanged', { data, getters });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
